export const LOOKBOOK_NAVIGATION = 'lookbook-navigation'

export function orderedLooks<T extends { id: string; createdAt: string }>(
  outfits: T[],
) {
  return outfits.toSorted(
    (a, b) =>
      a.createdAt.localeCompare(b.createdAt) || a.id.localeCompare(b.id),
  )
}

export function outfitPath(id: string) {
  return `/closet/outfits/${encodeURIComponent(id)}`
}

export function selectedLook(path: string, outfits: { id: string }[]) {
  return outfits.findIndex((outfit) => outfitPath(outfit.id) === path)
}

export function subscribeNavigation(callback: () => void) {
  window.addEventListener('popstate', callback)
  window.addEventListener(LOOKBOOK_NAVIGATION, callback)
  return () => {
    window.removeEventListener('popstate', callback)
    window.removeEventListener(LOOKBOOK_NAVIGATION, callback)
  }
}

export function getLookbookPath() {
  return window.location.pathname
}

export function getClosetView(): 'closet' | 'outfits' {
  return window.location.pathname.startsWith('/closet/outfits/') ||
    new URLSearchParams(window.location.search).get('view') === 'outfits'
    ? 'outfits'
    : 'closet'
}

export function navigateLookbook(id?: string, view?: 'closet') {
  const path = id
    ? outfitPath(id)
    : view === 'closet'
      ? '/closet'
      : '/closet?view=outfits'
  if (window.location.pathname + window.location.search === path) return
  window.history.pushState(null, '', path)
  window.dispatchEvent(new Event(LOOKBOOK_NAVIGATION))
}
